import React from 'react';
import Amenities from './Amenities';
import { ImageObj } from '../../../../types/ImageObj.types';
import Sustainability from './Sustainability';
import Service from './Service';
import DynamicTabs from '@components/DynamicTabs';
import Image from 'next/image';
import { Box } from '@mui/material';
import cn from './style.module.scss';
interface OrientalSpecificationProps {
  contentGraphicShapeBottom: any;
  tabThemeImageBackground: any;
  specificationDataBackground: any;
  specContentBackground: any;
  contentGraphicShapeTop?: string;
  containerShapeGraphicsBottom?: string;
  specificationTheme: {
    amenities: ImageObj[];
    services: ImageObj[];
    sustainability: ImageObj[];
    location: ImageObj[];
  };
  specificationMobileTheme: {
    amenities: ImageObj[];
    services: ImageObj[];
    sustainability: ImageObj[];
    location: ImageObj[];
  };
  t: any;
}

export default function SpecificationTab(props: OrientalSpecificationProps) {
  const { t } = props;

  const tabs = [
    {
      title: t['amenitiesTabHeading'],
      bgColor: '#272525',
      content: (
        <>
          <Amenities
            t={t}
            tabThemeImageBackground={props.tabThemeImageBackground}
            tabImages={props.specificationTheme.amenities}
            specificationDataBackground={props.specificationDataBackground}
            contentGraphicShapeTop={props.contentGraphicShapeTop}
            containerShapeGraphicsBottom={props.contentGraphicShapeTop}
          />
        </>
      ),
    },
    {
      title: t['serviceTabHeading'],
      bgColor: '#272525',
      content: (
        <>
          <Service
            t={t}
            tabThemeImageBackground={props.tabThemeImageBackground}
            tabImages={props.specificationTheme.services}
            specificationDataBackground={props.specificationDataBackground}
            contentGraphicShapeTop={props.contentGraphicShapeTop}
            containerShapeGraphicsBottom={props.contentGraphicShapeTop}
          />
        </>
      ),
    },
    {
      title: t['sustainabilityTabHeading'],
      bgColor: '#272525',
      content: (
        <>
          <Sustainability
            t={t}
            tabThemeImageBackground={props.tabThemeImageBackground}
            tabImages={props.specificationTheme.sustainability}
            specificationDataBackground={props.specificationDataBackground}
            contentGraphicShapeTop={props.contentGraphicShapeTop}
            containerShapeGraphicsBottom={props.contentGraphicShapeTop}
          />
        </>
      ),
    },
  ];
  return (
    <>
      <DynamicTabs
        tabs={tabs}
        wrapperClassName={cn.wildsSpecWrapper}
        className={cn.wildsSpecBlock}
        elementClass={cn.wildsTabElement}
        tabClass={cn.wildsTabNavWrapper}
        activeClassName={cn.activeLink}
        contentClass={cn.wildsTabContent}
        bgFlowClass={cn.flowElementClass}
      />
    </>
  );
}
